<div class="modal-header">
    <h4 class="modal-title">{{ title }}</h4>
</div>
<form name="form" #form="ngForm">
    <div class="modal-body">
        <h6 class="text-muted text-uppercase small mb-2">Damaged Utility Record</h6>
        <div class="row">
            <div class="col-sm-4 col-12">
                <div class="form-group">
                    <label for="damageDate">Date of Damage</label>
                    <wj-input-date [(ngModel)]="target.damageDate" name="damageDate" id="damageDate" [isRequired]="false"></wj-input-date>
                </div>
            </div>
            <div class="col-sm-4 col-12">
                <div class="form-group">
                    <label for="job">Job</label>
                    <wj-combo-box
                        [(ngModel)]="target.job"
                        name="job"
                        id="job"
                        [itemsSource]="jobList"
                        [displayMemberPath]="'display'"
                        [selectedValuePath]="'value'"
                        [isRequired]="false"
                        [isEditable]="true"
                    ></wj-combo-box>
                </div>
            </div>
            <div class="col-sm-4 col-12">
                <div class="form-group">
                    <label for="damagedByUserId">Employee That Damaged the Line</label>
                    <wj-combo-box
                        [(ngModel)]="target.damagedByUserId"
                        name="damagedByUserId"
                        id="damagedByUserId"
                        [itemsSource]="userList"
                        [displayMemberPath]="'display'"
                        [selectedValuePath]="'value'"
                        [isRequired]="false"
                    ></wj-combo-box>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <div class="form-group">
                    <label for="location">Location</label>
                    <app-voice-text-field
                        [(ngModel)]="target.location"
                        name="location"
                        inputId="location"
                        [rows]="2"
                        [showLocationButton]="true"
                    ></app-voice-text-field>
                </div>
            </div>
        </div>

        <hr />
        <h6 class="text-muted text-uppercase small mb-2">Utility Information</h6>
        <div class="row">
            <div class="col-sm-6 col-12">
                <div class="form-group">
                    <label for="blueStakeNumber">Blue Stake #</label>
                    <input type="text" class="form-control" [(ngModel)]="target.blueStakeNumber" name="blueStakeNumber" id="blueStakeNumber" />
                </div>
            </div>
            <div class="col-sm-6 col-12">
                <div class="form-group">
                    <label for="blueStakeValidDate">Blue Stake Valid Date</label>
                    <wj-input-date [(ngModel)]="target.blueStakeValidDate" name="blueStakeValidDate" id="blueStakeValidDate" [isRequired]="false"></wj-input-date>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-sm-6 col-12">
                <div class="form-group">
                    <label for="typeOfUtility">Type of Utility Struck</label>
                    <input type="text" class="form-control" [(ngModel)]="target.typeOfUtility" name="typeOfUtility" id="typeOfUtility" />
                </div>
            </div>
            <div class="col-sm-6 col-12">
                <div class="form-group">
                    <label for="utilityOwner">Owner of the Utility</label>
                    <input type="text" class="form-control" [(ngModel)]="target.utilityOwner" name="utilityOwner" id="utilityOwner" />
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-sm-6 col-12">
                <div class="form-group">
                    <label for="whoMarkedTheUtility">Who Marked the Utility</label>
                    <input type="text" class="form-control" [(ngModel)]="target.whoMarkedTheUtility" name="whoMarkedTheUtility" id="whoMarkedTheUtility" />
                </div>
            </div>
            <div class="col-sm-6 col-12">
                <div class="form-group">
                    <label for="whoRepairedTheUtility">Who Repaired the Utility</label>
                    <input type="text" class="form-control" [(ngModel)]="target.whoRepairedTheUtility" name="whoRepairedTheUtility" id="whoRepairedTheUtility" />
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-sm-6 col-12">
                <div class="form-group">
                    <label for="foremanUserId">Foreman</label>
                    <wj-combo-box
                        [(ngModel)]="target.foremanUserId"
                        name="foremanUserId"
                        id="foremanUserId"
                        [itemsSource]="userList"
                        [displayMemberPath]="'display'"
                        [selectedValuePath]="'value'"
                        [isRequired]="false"
                    ></wj-combo-box>
                </div>
            </div>
            <div class="col-sm-6 col-12">
                <div class="form-group">
                    <label for="superintendentUserId">Superintendent Notified</label>
                    <wj-combo-box
                        [(ngModel)]="target.superintendentUserId"
                        name="superintendentUserId"
                        id="superintendentUserId"
                        [itemsSource]="userList"
                        [displayMemberPath]="'display'"
                        [selectedValuePath]="'value'"
                        [isRequired]="false"
                    ></wj-combo-box>
                </div>
            </div>
        </div>

        <hr />
        <h6 class="text-muted text-uppercase small mb-2">Notifications</h6>
        <div class="row">
            <div class="col-sm-3 col-6">
                <div class="form-group">
                    <label for="pmNotified">PM Notified</label>
                    <wj-combo-box
                        [(ngModel)]="target.pmNotified"
                        name="pmNotified"
                        id="pmNotified"
                        [itemsSource]="answerOptions"
                        [displayMemberPath]="'display'"
                        [selectedValuePath]="'value'"
                        [isRequired]="false"
                    ></wj-combo-box>
                </div>
            </div>
            <div class="col-sm-3 col-6">
                <div class="form-group">
                    <label for="peNotified">PE Notified</label>
                    <wj-combo-box
                        [(ngModel)]="target.peNotified"
                        name="peNotified"
                        id="peNotified"
                        [itemsSource]="answerOptions"
                        [displayMemberPath]="'display'"
                        [selectedValuePath]="'value'"
                        [isRequired]="false"
                    ></wj-combo-box>
                </div>
            </div>
            <div class="col-sm-3 col-6">
                <div class="form-group">
                    <label for="safetyDepartmentNotified">Safety Dept Notified</label>
                    <wj-combo-box
                        [(ngModel)]="target.safetyDepartmentNotified"
                        name="safetyDepartmentNotified"
                        id="safetyDepartmentNotified"
                        [itemsSource]="answerOptions"
                        [displayMemberPath]="'display'"
                        [selectedValuePath]="'value'"
                        [isRequired]="false"
                    ></wj-combo-box>
                </div>
            </div>
            <div class="col-sm-3 col-6">
                <div class="form-group">
                    <label for="fireAndEmsNotified">Fire &amp; EMS Notified</label>
                    <wj-combo-box
                        [(ngModel)]="target.fireAndEmsNotified"
                        name="fireAndEmsNotified"
                        id="fireAndEmsNotified"
                        [itemsSource]="answerOptions"
                        [displayMemberPath]="'display'"
                        [selectedValuePath]="'value'"
                        [isRequired]="false"
                    ></wj-combo-box>
                </div>
            </div>
        </div>

        <hr />
        <h6 class="text-muted text-uppercase small mb-2">Damage Assessment</h6>
        <div class="row">
            <div class="col-12">
                <div class="form-group">
                    <label for="descriptionOfDamage">Description of Damage</label>
                    <app-voice-text-field
                        [(ngModel)]="target.descriptionOfDamage"
                        name="descriptionOfDamage"
                        inputId="descriptionOfDamage"
                        [rows]="3"
                    ></app-voice-text-field>
                </div>
            </div>
        </div>
        <div class="form-group">
            <label for="markedCorrectly">Was it marked correctly?</label>
            <div class="row g-2 align-items-center">
                <div class="col-sm-3 col-12">
                    <wj-combo-box
                        [(ngModel)]="target.markedCorrectly"
                        name="markedCorrectly"
                        id="markedCorrectly"
                        [itemsSource]="answerOptions"
                        [displayMemberPath]="'display'"
                        [selectedValuePath]="'value'"
                        [isRequired]="false"
                    ></wj-combo-box>
                </div>
                <div class="col-sm-9 col-12">
                    <input
                        type="text"
                        class="form-control"
                        placeholder="Comments"
                        [(ngModel)]="target.markedCorrectlyComments"
                        name="markedCorrectlyComments"
                        id="markedCorrectlyComments"
                    />
                </div>
            </div>
        </div>
        <div class="form-group">
            <label for="damagedBeforeExcavation">Damaged before excavation?</label>
            <div class="row g-2 align-items-center">
                <div class="col-sm-3 col-12">
                    <wj-combo-box
                        [(ngModel)]="target.damagedBeforeExcavation"
                        name="damagedBeforeExcavation"
                        id="damagedBeforeExcavation"
                        [itemsSource]="answerOptions"
                        [displayMemberPath]="'display'"
                        [selectedValuePath]="'value'"
                        [isRequired]="false"
                    ></wj-combo-box>
                </div>
                <div class="col-sm-9 col-12">
                    <input
                        type="text"
                        class="form-control"
                        placeholder="Comments"
                        [(ngModel)]="target.damagedBeforeExcavationComments"
                        name="damagedBeforeExcavationComments"
                        id="damagedBeforeExcavationComments"
                    />
                </div>
            </div>
        </div>
        <div class="form-group">
            <label for="vanConAtFault">Is VanCon at fault?</label>
            <div class="row g-2 align-items-center">
                <div class="col-sm-3 col-12">
                    <wj-combo-box
                        [(ngModel)]="target.vanConAtFault"
                        name="vanConAtFault"
                        id="vanConAtFault"
                        [itemsSource]="answerOptions"
                        [displayMemberPath]="'display'"
                        [selectedValuePath]="'value'"
                        [isRequired]="false"
                    ></wj-combo-box>
                </div>
                <div class="col-sm-9 col-12">
                    <input
                        type="text"
                        class="form-control"
                        placeholder="Comments"
                        [(ngModel)]="target.vanConAtFaultComments"
                        name="vanConAtFaultComments"
                        id="vanConAtFaultComments"
                    />
                </div>
            </div>
        </div>
        <div class="form-group">
            <label for="withinTwoFootTolerance">Within two-foot tolerance?</label>
            <div class="row g-2 align-items-center">
                <div class="col-sm-3 col-12">
                    <wj-combo-box
                        [(ngModel)]="target.withinTwoFootTolerance"
                        name="withinTwoFootTolerance"
                        id="withinTwoFootTolerance"
                        [itemsSource]="answerOptions"
                        [displayMemberPath]="'display'"
                        [selectedValuePath]="'value'"
                        [isRequired]="false"
                    ></wj-combo-box>
                </div>
                <div class="col-sm-9 col-12">
                    <input
                        type="text"
                        class="form-control"
                        placeholder="Comments"
                        [(ngModel)]="target.withinTwoFootToleranceComments"
                        name="withinTwoFootToleranceComments"
                        id="withinTwoFootToleranceComments"
                    />
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-sm-3 col-12">
                <div class="form-group">
                    <label for="prePhotosTaken">Pre-photos taken?</label>
                    <wj-combo-box
                        [(ngModel)]="target.prePhotosTaken"
                        name="prePhotosTaken"
                        id="prePhotosTaken"
                        [itemsSource]="answerOptions"
                        [displayMemberPath]="'display'"
                        [selectedValuePath]="'value'"
                        [isRequired]="false"
                    ></wj-combo-box>
                </div>
            </div>
        </div>

        <hr />
        <h6 class="text-muted text-uppercase small mb-2">Photos of the Damage</h6>
        @if (target.imageUrls && target.imageUrls.length > 0) {
            <div class="row">
                <label>Attached Photos</label>
                @for (url of target.imageUrls; track url) {
                    <div class="col-sm-4 col-6" style="margin-bottom: 10px">
                        <img style="width: 100%" [src]="'./Resources/Images/DamagedUtility/' + url + '?w=300'" />
                    </div>
                }
            </div>
        }
        @if (images && images.length > 0) {
            <div class="row">
                <label>Photos To Upload</label>
                @for (image of images; track image) {
                    <div class="col-sm-4 col-6" style="margin-bottom: 10px">
                        <div class="close-x" (click)="removeImage(image)">
                            <fa-icon [icon]="faX"></fa-icon>
                        </div>
                        <img style="width: 100%" [src]="image.url" />
                    </div>
                }
            </div>
        }
        @if (progress > 0 && progress < 100) {
            <div class="row">
                <div class="col-12">
                    <div class="progress">
                        <div
                            class="progress-bar"
                            role="progressbar"
                            [ngStyle]="{ 'width.%': progress }"
                            aria-valuenow="25"
                            aria-valuemin="0"
                            aria-valuemax="100"
                        >
                            {{ progress }}%
                        </div>
                    </div>
                </div>
            </div>
        }

        <hr />
        <h6 class="text-muted text-uppercase small mb-2">Sign-off</h6>
        <div class="row">
            <div class="col-sm-6 col-12">
                <div class="form-group">
                    <label for="signedByUserId">Signed By (Employee)</label>
                    <wj-combo-box
                        [(ngModel)]="target.signedByUserId"
                        name="signedByUserId"
                        id="signedByUserId"
                        [itemsSource]="userList"
                        [displayMemberPath]="'display'"
                        [selectedValuePath]="'value'"
                        [isRequired]="false"
                    ></wj-combo-box>
                </div>
            </div>
            <div class="col-sm-6 col-12">
                <div class="form-group">
                    <label for="signedDate">Sign-off Date</label>
                    <wj-input-date [(ngModel)]="target.signedDate" name="signedDate" id="signedDate" [isRequired]="false"></wj-input-date>
                </div>
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-secondary" style="margin-right: auto" (click)="fileInput.click()">Upload Photo(s)</button>
        <input style="display: none" type="file" (change)="onFileChanged($event)" accept="image/*" #fileInput multiple />
        <button id="btnSave" type="submit" class="btn btn-primary" (click)="save()" [disabled]="form.invalid || isSaving">
            @if (isSaving) {
                <span><fa-icon [icon]="faSpinner" [animation]="'spin'"></fa-icon>&nbsp;Saving</span>
            } @else {
                <span>Save</span>
            }
        </button>
        <button id="btnCancel" type="button" class="btn btn-secondary" (click)="cancel()" [disabled]="isSaving">Cancel</button>
    </div>
</form>
